module.exports = __webpack_public_path__ + "89bc4e2988a7edefb73072285aecc58a.jpg";